import { fiflboxApi } from './api';
/**
 * distribute item when results of function is same
 * @param arr
 * @param func
 * @returns {Array}
 *
 * @example
 *
 * distributeBy([1.2, 2.1, 2.5, 2.6, 3, 3.1, 3.5], Math.floor)
 * // => [[1.2, 2.1, 3], [2.5, 3.1], [2.6, 3.5]]
 */

export function distributeBy(arr, func) {
  let resultArr = [];

  arr.forEach(item => {
    let filteredArr = resultArr.filter(resultSubArr => {
      let foundArrItems = resultSubArr.filter(resultArr =>
        func(resultArr, item)
      );

      return foundArrItems.length === 0;
    });

    if (filteredArr.length === 0) {
      resultArr.push([item]);
    } else {
      filteredArr[0].push(item);
    }
  });

  return resultArr;
}

export function makeCategoriesForSelectBox(data, prefixName, selectedValue) {
  return data
    .filter(
      category =>
        selectedValue
          ? !category.is_removed ||
            category[prefixName].filter(item => item.id === selectedValue)
              .length
          : !category.is_removed
    )
    .map(category => {
      let categoryOptions = category[prefixName]
        .filter(
          item =>
            selectedValue
              ? !item.is_removed || item.id === selectedValue
              : !item.is_removed
        )
        .map(item => {
          return {
            value: item.id,
            label: item.name,
            is_removed: item.is_removed
          };
        });

      return {
        label: category.name,
        options: categoryOptions
      };
    });
}

export function sortRemoveForSelectBox(data) {
  return data.sort((prev, next) => {
    if (prev.is_removed) {
      return 1;
    }

    if (next.is_removed) {
      return -1;
    }

    return 0;
  });
}

export function makeParentMembershipsForSelectBox(
  categories,
  memberships,
  selectedValue
) {
  let data = categories.map(category => {
    const options = memberships
      .filter(
        membership =>
          membership.category === category.id &&
          (selectedValue
            ? selectedValue === membership.id || !membership.is_removed
            : !membership.is_removed)
      )
      .map(membership => {
        return {
          label: membership.name,
          value: membership.id,
          is_removed: membership.is_removed
        };
      });

    return {
      label: category.name,
      is_removed: category.is_removed,
      options
    };
  });

  data = data.filter(item => {
    if (!item.is_removed) {
      return true;
    }

    if (item.options.filter(option => option.value === selectedValue).length) {
      return true;
    }

    return false;
  });

  return data;
}

export function makeInstructorsForSelectBox(instructors, selectedValues) {
  const data = instructors
    .filter(
      instructor =>
        !instructor.is_removed || selectedValues.includes(instructor.id)
    )
    .map(instructor => {
      return {
        value: instructor.id,
        label: instructor.name,
        is_removed: instructor.is_removed
      };
    });
  return data;
}
